import axiosClient from 'utils/axiosClient';
import api from 'api';
import {formData} from 'utils/helpers/formData';

const getBenefitApplications = async (params?: any) => {
	const response = await axiosClient.get(api.RATING.BENEFIT_APPLICATIONS.BENEFIT_APPLICATIONS, {params});
	return response.data;
};

const getBenefitApplicationByID = async (id: number) => {
	const response = await axiosClient.get(api.RATING.BENEFIT_APPLICATIONS.BENEFIT_APPLICATIONS + `/` + id);
	return response.data;
};

const createBenefitApplication = async (data: any) => {
	const response = await axiosClient.post(api.RATING.BENEFIT_APPLICATIONS.BENEFIT_APPLICATIONS, formData(data));
	return response.data;
};

const approveBenefitApplication = async (id: number, data: any) => {
	const response = await axiosClient.patch(
		api.RATING.BENEFIT_APPLICATIONS.BENEFIT_APPLICATIONS + `/` + id + `/approve`,
		data
	);
	return response.data;
};
const completeBenefitApplication = async (id: number, data: any) => {
	const response = await axiosClient.patch(
		api.RATING.BENEFIT_APPLICATIONS.BENEFIT_APPLICATIONS + `/` + id + `/complete`,
		data
	);
	return response.data;
};
const cancelBenefitApplication = async (id: number, data: any) => {
	const response = await axiosClient.patch(
		api.RATING.BENEFIT_APPLICATIONS.BENEFIT_APPLICATIONS + `/` + id + `/cancel`,
		data
	);
	return response.data;
};
const deleteBenefitApplication = async (id: number) => {
	const response = await axiosClient.delete(
		api.RATING.BENEFIT_APPLICATIONS.BENEFIT_APPLICATIONS + `/` + id
	);
	return response.data;
};

const service = {
	getBenefitApplications,
	getBenefitApplicationByID,
	createBenefitApplication,
	cancelBenefitApplication,
	completeBenefitApplication,
	approveBenefitApplication,
	deleteBenefitApplication
};
export default service;
